'use es6';

import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
import Routes from 'ContentUtils/Routes';
import { gate } from 'hub-http/gates';
const themeUrl = 'designmanager/v1/themes';
const fontsUrl = 'content/fonts/v1';
export function fetchByPath(themePath) {
  const themeSettingsPath = Routes.isUngated(gate('ThemesAndModules:ThemeSettingsChirpMigration')) ? 'with-settings' : 'settings';
  return http.get(`${themeUrl}/by-path/${encodeURIComponent(themePath)}/${themeSettingsPath}`, {
    timeout: 15000,
    query: {
      portalId: PortalIdParser.get()
    }
  });
}
export function fetchThemeCustomFonts(themePath) {
  return http.get(`${fontsUrl}/by-theme-path/${themePath}`, {
    query: {
      portalId: PortalIdParser.get()
    }
  });
}